import { alertSuccess } from "../../utils/feedback";
import axiosInstance from "../../axios/index";
import { SET_ANSWERS, SET_FORWARDED } from "../types/forwardTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { fetchIncompteteQuizById } from "./quizzesActionCreators";

export const setAnswers = (answers) => ({
  type: SET_ANSWERS,
  payload: answers,
});

export const selectForwarded = (item) => ({
  type: SET_FORWARDED,
  payload: item,
});

export const requestAddAnswersQuiz = (data, history, orgaId, accountType) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const answers =
        accountType === "enterprise"
          ? await axiosInstance.put(`/survey/addanswers?orga_id=${orgaId}`, {
              answers: data.answers,
              identifier: data.identifier,
              is_completed: data.isCompleted,
              quiz_id: data.quiz_id,
              version: data.version,
              pourcentage: data.pourcentage,
            })
          : await axiosInstance.put(`/survey/addanswers`, {
              answers: data.answers,
              identifier: data.identifier,
              is_completed: data.isCompleted,
              quiz_id: data.quiz_id,
              version: data.version,
              pourcentage: data.pourcentage,
            });
      const res = await axiosInstance.post(
        `/survey/Answer_forwarded/${data.forward_id}`,
        {
          forward_id: data.forward_id,
          user_answers: data.user_answers,
        }
      );
      dispatch(setAnswers(data.answers));
      dispatch(requestSucceeded());
      setTimeout(() => {
        history.push("/quizzes");
      }, "1000");
      if (res) {
        alertSuccess(res.data);
        alertSuccess(answers.data);
      }
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const fetchForwardedById = (id, history) => {
  return async (dispatch) => {
    dispatch(requestStarted());
    try {
      const res = await axiosInstance.get(`/survey/get_forwarded/${id}`);

      dispatch(requestSucceeded());
      const item = res.data;
      dispatch(setAnswers(item?.answers));
      dispatch(selectForwarded(item));
    } catch (error) {
      if (error?.response?.data?.message === "Already answered") {
        history.push("/Already-Answered");
      } else {
        dispatch(requestFailed(error.response.data));
        history.push("/quizzes");
      }
    }
  };
};

export const cancelForwrdedQuetion = (
  forwardId,
  useCaseId,
  quizId,
  orgaId,
  accountType
) => {
  return async (dispatch) => {
    dispatch(requestStarted("quizz"));
    try {
      const res =
        accountType === "enterprise"
          ? await axiosInstance.post(
              `/survey/cancel_forward?orga_id=${orgaId}`,
              {
                forward_id: forwardId,
                usecase_id: useCaseId,
                identifier: quizId,
                confirm_cancel: true,
              }
            )
          : await axiosInstance.post("/survey/cancel_forward", {
              forward_id: forwardId,
              usecase_id: useCaseId,
              identifier: quizId,
              confirm_cancel: true,
            });
      setTimeout(() => {
        dispatch(requestSucceeded());
        alertSuccess(res.data);
        dispatch(fetchIncompteteQuizById(quizId, orgaId, accountType));
      }, 2000);
    } catch (error) {
      console.log({ error });
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
